import { isEqual } from 'lodash-es'

export function requestCache<Fn extends (...args: unknown[]) => Promise<unknown>>(): MethodDecorator {
  const requestCacheMap = new Map<
    string,
    {
      asyncRequest: Promise<unknown>
      args: unknown[]
    }
  >()

  return function (target, propertyKey, descriptor: PropertyDescriptor) {
    const sourceMethod: Fn = descriptor.value

    descriptor.value = async function (...args: unknown[]) {
      const argsKey = JSON.stringify(args)
      const preRequest = requestCacheMap.get(argsKey)

      if (preRequest && isEqual(preRequest.args, args)) {
        return preRequest.asyncRequest
      } else {
        try {
          const asyncRequest = sourceMethod.apply(this, args).finally(() => {
            requestCacheMap.delete(argsKey)
          })

          requestCacheMap.set(argsKey, {
            asyncRequest,
            args,
          })
        } catch (error) {
          console.log('[RequestCache] request error:', error, sourceMethod)
          requestCacheMap.delete(argsKey)

          throw error
        }
      }
    }
  }
}
